import { Loader } from '@googlemaps/js-api-loader';

// FHF live key
const GOOGLE_MAP_KEY_API = 'AIzaSyAYGlI2sdodgcTfKrfwvKgVVMR0fJKlT8w';

export default async function googleMapPlacesApiLoader(): Promise<google.maps.PlacesLibrary> {
    const loader = new Loader({
        apiKey: GOOGLE_MAP_KEY_API,
        version: 'weekly',
    });

    const placesApiClient = await loader.importLibrary('places');

    return placesApiClient;
}
